import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete, Box, Button, Stack,
  Table,
  TableBody,
  TableCell,
  TableRow, TextField, Typography
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Toolbar from "@mui/material/Toolbar";
import React, { useState } from "react";
import { nbfMissingOrder, nbfProductionStatus } from "../../api/restApi";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MissingItemModal({
  open,
  handleClose,
  missItem,
  selectedDate,
  selectedRowId,
  handleStatus,
}) {
  const [selectedReason, setSelectedReason] = useState(" ");
  const reasons = ["گاہک کی طرف سے آرڈر تبدیل کر دیا گیا", "آرڈر تیار نہیں ہوا", "ناقص معیار"];
  const handleSelectReason = async (event, newValue) => {
    setSelectedReason(newValue);
  };

  const handleSubmit = async () => {
    try {
      const missingItem = missItem.map((item) => {
        return {
          productName: item.ProductName,
          quantityMissing: item.quantityMissing,
          reason: selectedReason,
        };
      });
      await nbfMissingOrder(selectedRowId, selectedDate, missingItem);
      handleClose();
      const date=selectedDate;
      const id=selectedRowId;
      await nbfProductionStatus(date,id);
      handleStatus(selectedDate);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{minHeight:'300px'}}
      >
        <Box sx={{width:'550px', minHeight:'350px',maxHeight:'650px'}}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" align="center">
          یہ کچھ مصنوعات کم ہیں
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <Stack
          alignItems="center"
          marginTop="1rem"
          direction="row"
          justifyContent="center"
          spacing={1}
          width="500px"
        >
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={reasons}
            sx={{
              minWidth: 200,
              display: "flex",
              justifyContent: "center",
            }}
            value={selectedReason}
            onChange={handleSelectReason}
            renderInput={(params) => (
              <TextField {...params} label="Select a reason" />
            )}
          />
          <Button
            variant="outlined"
            sx={{ padding: "13px" }}
            onClick={handleSubmit}
          >
            Update
          </Button>
        </Stack>
        <Stack direction={"row"} justifyContent="center">
          <Table
            sx={{ maxWidth: 480, marginTop: "1rem" }}
            aria-label="simple table"
          >
            <TableBody>
              {missItem &&
                missItem.map((row, index) => {
                  return (
                    <>
                      <TableRow key={index}>
                        <TableCell align="left" style={{ fontSize: 15 }}>
                          {row.quantityMissing}{" "}
                        </TableCell>
                        <TableCell align="right" style={{ fontSize: 15 }}>
                          {row.ProductName}{" "}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })}
            </TableBody>
          </Table>
        </Stack>
        </Box>
      </Dialog>
    </div>
  );
}
